import { render, staticRenderFns } from "./StSection.vue?vue&type=template&id=45c60078&scoped=true"
import script from "./StSection.vue?vue&type=script&lang=js"
export * from "./StSection.vue?vue&type=script&lang=js"
import style0 from "./StSection.vue?vue&type=style&index=0&id=45c60078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c60078",
  null
  
)

export default component.exports